






























































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Wallet from '@/models/Accounts/DepositAccounts/Wallets/Wallet';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import SingleAccountReportDialog from '@/components/Reporting/Reports/SingleAccountReportDialog.vue';
import WalletsTransactionDetailsDialog from '@/components/Accounts/DepositAccounts/Wallets/Transactions/WalletsTransactionDetailsDialog.vue';
import WalletsTransactionRichDataDialog from '@/components/Accounts/DepositAccounts/Wallets/Transactions/WalletsTransactionRichDataDialog.vue';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import TransactionsOptions from "@/models/Accounts/Shared/Transactions/TransactionsOptions";
import TransactionsOrderOptions from "@/models/Accounts/Shared/Transactions/TransactionsOrderOptions";
import DebitCreditCode from '@/models/Shared/DebitCreditCode';
import { Debounce } from 'vue-debounce-decorator';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import AccountType from '@/models/Shared/AccountType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'WalletTransactionsList', components: { SingleAccountReportDialog, WalletsTransactionDetailsDialog, WalletsTransactionRichDataDialog } })
export default class extends SaascadaVue {

    @Prop({required: true})
    wallet: Wallet;

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    AccountType = AccountType;
    TransactionsOrderOptions = TransactionsOrderOptions;
    transactionsSelection = TransactionsOptions.Cleared;

    get headers() {
        const isDisplayDate = this.transactionsOrderSelection === TransactionsOrderOptions.DisplayDate;
        const dateColumnHeader = isDisplayDate ? this.$t('pageText.depositAccounts.fields.displayDate') : this.$t('pageText.depositAccounts.fields.createdAt');

        // NOTE: The 'value' field here is needed for local searching on the table, until server side searching is added
        return [
            { text: this.$t('pageText.depositAccounts.fields.reference'), sortable: false, value: 'transactionReference', width: '20%' },
            { text: this.$t('pageText.depositAccounts.fields.transactionType'), sortable: false, value: 'transactionType', width: '15%' },
            { text: this.$t('pageText.depositAccounts.fields.direction'), sortable: false, width: '10%' },
            { text: this.$t('pageText.depositAccounts.fields.amount'), sortable: false, width: '10%' },
            { text: this.$t('pageText.depositAccounts.fields.balanceAfter'), sortable: false, width: '10%' },
            { text: dateColumnHeader, sortable: false, width: '20%' },
            { text: this.$t('pageText.depositAccounts.fields.moreInfo'), sortable: false, width: '15%' },
        ];
    }

    clearedTransactionsPage = 1;
    pendingTransactionsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            if (this.transactionsSelection === TransactionsOptions.Cleared) {
                this.clearedTransactionsPage = +page;
            }
            else {
                this.pendingTransactionsPage = +page;
            }
        }
    }

    @Watch('clearedTransactionsPage')
    async onClearedTransactionsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.clearedTransactionsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.clearedTransactionsPage}` } });
        }
        await DepositAccountModule.getWalletTransactions({id: this.wallet.id, page: this.clearedTransactionsPage});
    }

    @Watch('pendingTransactionsPage')
    async onPendingTransactionsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.pendingTransactionsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.pendingTransactionsPage}` } });
        }
        await DepositAccountModule.getWalletPendingTransactions({id: this.wallet.id, page: this.pendingTransactionsPage});
    }

    @Watch('transactionsOrderSelection')
    async onTransactionsOrderSelectionChanged() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            await DepositAccountModule.getWalletTransactions({id: this.wallet.id, page: this.clearedTransactionsPage});
        }
        else {
            await DepositAccountModule.getWalletPendingTransactions({id: this.wallet.id, page: this.pendingTransactionsPage});
        }
    }

    get account() {
        return DepositAccountModule.depositAccount;
    }

    get transactionsOptions() {
        return ListUtils.transactionsOptions();
    }

    get isPendingTransactions() {
        return this.transactionsSelection === TransactionsOptions.Pending;
    }

    get transactionsOrderOptions() {
        return ListUtils.transactionsOrderOptions();
    }

    get transactionsOrderSelection() {
        return DepositAccountModule.currentDepositAccountWalletTransactionsOrder;
    }

    set transactionsOrderSelection(order: TransactionsOrderOptions) {
        DepositAccountModule.updateCurrentDepositAccountWalletTransactionsOrder(order);
    }

    get transactions() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return DepositAccountModule.currentDepositAccountWalletTransactions;
        }
        else {
            return DepositAccountModule.currentDepositAccountWalletPendingTransactions;
        }
    }

    get transactionsPage() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return this.clearedTransactionsPage;
        }
        else {
            return this.pendingTransactionsPage;
        }
    }

    set transactionsPage(pageNumber) {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            this.clearedTransactionsPage = pageNumber;
        }
        else {
            this.pendingTransactionsPage = pageNumber;
        }
    }

    get totalTransactionsPages() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return DepositAccountModule.totalDepositAccountWalletTransactionsPages;
        }
        else {
            return DepositAccountModule.totalDepositAccountWalletPendingTransactionsPages;
        }
    }

    get loading() {
        if (this.transactionsSelection === TransactionsOptions.Cleared) {
            return DepositAccountModule.loadingTransactions;
        }
        else {
            return DepositAccountModule.loadingPendingTransactions;
        }
    }

    get search() {
        return DepositAccountModule.currentDepositAccountWalletTransactionsSearch;
    }

    set search(searchText: string) {
        DepositAccountModule.updateCurrentDepositAccountWalletTransactionsSearch(searchText);
    }

    get pageSize() {
        return DepositAccountModule.pageSize;
    }

    getDebitCreditClass(code: DebitCreditCode) {
        if (code === DebitCreditCode.debit) {
            return "error--text";
        }
        else {
            return "success--text";
        }
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        // Note that when the search changes it puts the user back to the first page, incase there are new transactions
        await DepositAccountModule.getWalletTransactions({id: this.wallet.id, page: 1});
        await DepositAccountModule.getWalletPendingTransactions({id: this.wallet.id, page: 1});
    }

    // TODO: This is a workaround until the API returns the balance in an Amount object format
    formattedBalance(transaction: Transaction) {
        return {
            amount: transaction.balance,
            currency: transaction.amount.currency
        }
    }
}
